module.exports = __webpack_public_path__ + "static/media/026-girl-4.f06a9dc4.svg";